import React, { useEffect, lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import VideoTestimonial from '@/components/home/VideoTestimonial';
import Video3DWrapper from '@/components/home/Video3DWrapper';
import { MotionConfig } from 'framer-motion';
import { Reveal } from '@/components/motion/Reveal';

const Hero = lazy(() => import('@/components/home/Hero'));
const FeaturedServices = lazy(() => import('@/components/home/FeaturedServices'));
const FeaturedProjects = lazy(() => import('@/components/home/FeaturedProjects'));
const Testimonials = lazy(() => import('@/components/shared/FacebookReviews'));
const CTASection = lazy(() => import('@/components/home/CTASection'));
const ProductSpotlight = lazy(() => import('@/components/home/ProductSpotlight'));
const WhatsAppButton = lazy(() => import('@/components/WhatsAppButton'));

const Index = () => {
  useEffect(() => {
    // Add a subtle entrance animation to the page
    document.body.classList.add('fade-in');
    return () => {
      document.body.classList.remove('fade-in');
    };
  }, []);

  // Listen for language changes to update content dynamically
  useEffect(() => {
    const handleLanguageChange = (event) => {
      // When language changes, we can trigger UI updates here if needed
      console.log('Language changed to:', event.detail?.language || localStorage.getItem('lang'));
      // You could update page content based on language here
    };
    
    window.addEventListener('language-changed', handleLanguageChange);
    return () => {
      window.removeEventListener('language-changed', handleLanguageChange);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Web Design, Software & Google Ads for US Businesses | Omnicraft</title>
        <meta name="description" content="Omnicraft Services builds hand-coded websites, custom software and AI automation, and runs flat-fee Google Ads management for US small businesses." />
        <link rel="preconnect" href="https://www.youtube.com" />
        <link rel="icon" type="image/png" href="/logo.png" />
        <link rel="apple-touch-icon" href="/logo.png" />
      </Helmet>
      <div className="min-h-screen animate-fade-in">
        <MotionConfig reducedMotion="user">
          <Suspense fallback={<div className="min-h-screen" />}>
            <Hero />
          </Suspense>
          <Reveal className="container-custom">
            <Video3DWrapper>
              <VideoTestimonial />
            </Video3DWrapper>
          </Reveal>
          <Suspense fallback={<div className="min-h-[600px]" />}>
            <FeaturedServices />
            <ProductSpotlight />
            <FeaturedProjects />
            <Reveal>
              <Testimonials />
            </Reveal>
            <CTASection />
          </Suspense>
        </MotionConfig>
      </div>
    </>
  );
};

export default Index;
